import React from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';

//reemplazando valores de iniciales en estado

export default function ModalConcept(props) {
  const concept = props.model;

  return (
    <Modal
      title="Concepto"
      model={concept}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="pymt/concept"
    >
      <TextField
        label="Descripción"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        defaultValue={!!concept ? concept.description : ''}
        required
      />
    </Modal>
  );
}
